import { render, staticRenderFns } from "./FormSideNav.vue?vue&type=template&id=ed7f4fba&"
import script from "./FormSideNav.vue?vue&type=script&lang=js&"
export * from "./FormSideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports